import React, { useRef, useState, useEffect } from "react";
import Sidebar from "../../components/Structure/Sidebar";
import HoldOn from 'react-hold-on';
import { useDispatch, useSelector } from "react-redux";
import { getTransactionListByStudentId } from "../../@redux/Action/Transaction";
import { FaPlus, FaSearch, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { MenuItem, Modal as MuiModal, Box } from "@mui/material";
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CustomTextField } from "../../utils/Fields";
import { FxRateAPI } from '../../@redux/Action/FX_Rate_Action';

function TransactionPage({studentId}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [transactionData, setTransactionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [showFxRateModal, setShowFxRateModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const transactionsPerPage = 10;

    const fxRateValue = useSelector((state) => state.fxRate?.fxRateRes);
    const [fxRateQuery, setFxRateQuery] = useState({
        'destination_currency': '',
        'destination_amount': ''
    });

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 800,
        bgcolor: 'background.paper',
        boxShadow: 24,
        maxHeight: '90vh',
        overflow: 'auto',
        borderRadius: '12px',
        border: 'none'
    };

    const fetchTransactionData = async (studentId) => {
        try {
            const data = await dispatch(getTransactionListByStudentId(studentId));
            console.log("Transaction data from API:", data);
            if (Array.isArray(data.fetchTransfer)) {
                setTransactionData(data.fetchTransfer);
            } else if (data.fetchTransfer && typeof data.fetchTransfer === 'object') {
                setTransactionData([data.fetchTransfer]);
            } else {
                setTransactionData([]);
            }
        } catch (error) {
            console.error("Error fetching transaction data:", error);
            setTransactionData([]);
        } finally {
            setIsLoading(false);
        }
    };
    console.log("Transaction data:", transactionData);
    useEffect(() => {
        fetchTransactionData(studentId);
    }, [dispatch, studentId]);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setFxRateQuery(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (name === 'destination_amount') {
            dispatch(FxRateAPI({
                ...fxRateQuery,
                [name]: value
            }));
        }
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
    };

    const handleDetailsModalOpen = (transaction) => {
        setSelectedTransaction(transaction);
        setOpenDetailsModal(true);
    };

    const handleDetailsModalClose = () => {
        setSelectedTransaction(null);
        setOpenDetailsModal(false);
    };

    const handleAddTransaction = () => {
        setShowFxRateModal(true);
    };

    const handleCloseFxRateModal = () => {
        setShowFxRateModal(false);
    };

    const handleProceed = (e) => {
        e.preventDefault();
        navigate(`/onboarding`);
    }

    const formatNumber = (value) => {
        if (value === undefined || value === null) {
            return '';
        }
        return Number(value).toFixed(2);
    }

    // Filter transactions based on search term
    const filteredTransactions = transactionData.filter(transaction =>
        Object.entries(transaction).some(([key, value]) => 
            value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Get current transactions
    const indexOfLastTransaction = currentPage * transactionsPerPage;
    const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
    const currentTransactions = filteredTransactions.slice(indexOfFirstTransaction, indexOfLastTransaction);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Calculate total pages
    const totalPages = Math.ceil(filteredTransactions.length / transactionsPerPage);

    return (
        <div className="d-md-flex" style={{ height: "100vh", backgroundColor: "#f8f9fa" }}>
            {/* left section */}
            <Sidebar />

            {/* right section */}
            <div className="col-12 col-md-9 px-4 rounded-4 d-flex flex-column overflow-hidden">
                <div className="my-4 mx-auto w-100 d-flex flex-column h-100">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="mb-0 text-success">Transactions</h2>
                        <button className="btn btn-success d-flex align-items-center" onClick={handleAddTransaction}>
                            <FaPlus className="me-2" /> Add Transaction
                        </button>
                    </div>

                    <MuiModal
                        open={openDetailsModal}
                        onClose={handleDetailsModalClose}
                        aria-labelledby="details-modal-title"
                        aria-describedby="details-modal-description"
                    >
                        <Box sx={{
                            ...modalStyle,
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: 'none',
                            overflow: 'visible'
                        }} className="p-0">
                            <div className="modal-header bg-success text-white p-4 position-relative">
                                <h4 className="mb-0">Transaction Details</h4>
                                <FaTimes 
                                    className="position-absolute" 
                                    style={{top: '20px', right: '20px', cursor: 'pointer'}}
                                    onClick={handleDetailsModalClose}
                                />
                            </div>

                            {selectedTransaction && (
                                <div className="modal-body p-4">
                                    <div className="row mb-4">
                                        <h5 className="text-success mb-3">Basic Information</h5>
                                        <div className="col-md-4">
                                            <CustomTextField
                                                label="Transaction ID"
                                                value={selectedTransaction.transaction_id || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <CustomTextField
                                                label="Beneficiary ID"
                                                value={selectedTransaction.beneficiary_id || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <CustomTextField
                                                label="Remitter ID"
                                                value={selectedTransaction.remitter_id || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-4">
                                        <h5 className="text-success mb-3">Currency & Amount Details</h5>
                                        <div className="col-md-3">
                                            <CustomTextField
                                                label="Source Currency"
                                                value={selectedTransaction.source_currency || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <CustomTextField
                                                label="Destination Currency"
                                                value={selectedTransaction.destination_currency || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <CustomTextField
                                                label="Destination Amount"
                                                value={selectedTransaction.destination_amount || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <CustomTextField
                                                label="Total Amount"
                                                value={selectedTransaction.total_amount || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <h5 className="text-success mb-3">Payment Information</h5>
                                        <div className="col-md-4">
                                            <CustomTextField
                                                label="Payment Status"
                                                value={selectedTransaction.payment_status || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <CustomTextField
                                                label="Payment Reference"
                                                value={selectedTransaction.payment_reference_number || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <CustomTextField
                                                label="Transaction Purpose"
                                                value={selectedTransaction.transaction_purpose || ''}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{
                                                    readOnly: true,
                                                    style: { backgroundColor: '#fff' }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Box>
                    </MuiModal>

                    <div className="mb-3 position-relative">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search transactions..."
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                        <FaSearch className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" />
                    </div>
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : currentTransactions.length > 0 ? (
                        <div className="table-responsive flex-grow-1 bg-white rounded shadow-sm" style={{ fontSize: '0.9rem' }}>
                            <table className="table table-hover mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="text-success fw-bold py-3 px-3">Transaction ID</th>
                                        <th className="text-success fw-bold py-3 px-3">Source Currency</th>
                                        <th className="text-success fw-bold py-3 px-3">Source Amount</th>
                                        <th className="text-success fw-bold py-3 px-3">Destination Currency</th>
                                        <th className="text-success fw-bold py-3 px-3">Total Amount</th>
                                        <th className="text-success fw-bold py-3 px-3">Purpose</th>
                                        <th className="text-success fw-bold py-3 px-3">Payment Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentTransactions.map((transaction, index) => (
                                        <tr key={index} 
                                            className="align-middle cursor-pointer" 
                                            onClick={() => handleDetailsModalOpen(transaction)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td className="py-2 px-3">{transaction.transaction_id}</td>
                                            <td className="py-2 px-3">{transaction.source_currency}</td>
                                            <td className="py-2 px-3">{transaction.destination_amount}</td>
                                            <td className="py-2 px-3">{transaction.destination_currency}</td>
                                            <td className="py-2 px-3">{transaction.total_amount}</td>
                                            <td className="py-2 px-3">{transaction.transaction_purpose}</td>
                                            <td className="py-2 px-3">
                                                <span
                                                    className={`badge ${
                                                        transaction.payment_status === "Completed"
                                                            ? "bg-success"
                                                            : "bg-warning"
                                                    }`}
                                                >
                                                    {transaction.payment_status}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="alert alert-info" role="alert">
                            No Transaction data available.
                        </div>
                    )}
                    <nav className="mt-4">
                        <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link text-success" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                    <FaChevronLeft />
                                </button>
                            </li>
                            {totalPages <= 5 ? (
                                [...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                        <button className={`page-link ${currentPage === i + 1 ? 'bg-success text-white' : 'text-success'}`} onClick={() => paginate(i + 1)}>{i + 1}</button>
                                    </li>
                                ))
                            ) : (
                                <>
                                    {currentPage > 2 && (
                                        <>
                                            <li className="page-item"><button className="page-link text-success" onClick={() => paginate(1)}>1</button></li>
                                            {currentPage > 3 && <li className="page-item disabled"><span className="page-link text-success">...</span></li>}
                                        </>
                                    )}
                                    {[...Array(5)].map((_, i) => {
                                        const pageNum = currentPage + i - 2;
                                        return pageNum > 0 && pageNum <= totalPages ? (
                                            <li key={i} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                <button className={`page-link ${currentPage === pageNum ? 'bg-success text-white' : 'text-success'}`} onClick={() => paginate(pageNum)}>{pageNum}</button>
                                            </li>
                                        ) : null;
                                    })}
                                    {currentPage < totalPages - 1 && (
                                        <>
                                            {currentPage < totalPages - 2 && <li className="page-item disabled"><span className="page-link text-success">...</span></li>}
                                            <li className="page-item"><button className="page-link text-success" onClick={() => paginate(totalPages)}>{totalPages}</button></li>
                                        </>
                                    )}
                                </>
                            )}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link text-success" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <FaChevronRight />
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            {/* FX Rate Modal */}
            <Modal show={showFxRateModal} onHide={handleCloseFxRateModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-success">Check exchange rate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='bg-white px-3 py-3 rounded-4'>
                        <form onSubmit={handleProceed}>
                            <div className='my-4'>
                                <p className='text-success'>Fees to pay</p>
                                <div className='d-flex justify-content-center gap-5'>
                                    <div className='col-5'>
                                        <select
                                            className='form-select text-success w-100 shadow-none'
                                            name='destination_currency'
                                            value={fxRateQuery.destination_currency}
                                            onChange={handleOnChange}
                                            required
                                        >
                                            <option value=''>Choose currency</option>
                                            <option value="USD">USD</option>
                                            <option value="AUD">AUD</option>
                                            <option value="SGD">SGD</option>
                                            <option value="CAD">CAD</option>
                                            <option value="GBP">GBP</option>
                                            <option value="EURO">EURO</option>
                                        </select>
                                    </div>
                                    <div className='col-5'>
                                        <input
                                            type='number'
                                            className='form-control w-100 shadow-none text-success'
                                            name='destination_amount'
                                            placeholder='Enter Amount'
                                            value={fxRateQuery.destination_amount}
                                            onChange={handleOnChange}
                                            disabled={!fxRateQuery.destination_currency}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='my-4'>
                                <div className='mb-3 text-success'><span style={{ textDecoration: 'underline' }}>Applied Charges</span></div>
                                <div className='d-flex justify-content-center gap-5 text-secondary' style={{ fontSize: '0.95rem' }}>
                                    <div className='col-5'>
                                        <ul className='list-unstyled text-success fw-bold'>
                                            <li>Fx_rate</li>
                                            <li>Fees</li>
                                            <li>TCS_Rate</li>
                                        </ul>
                                    </div>
                                    <div className='col-5 text-start'>
                                        <ul className='list-unstyled text-end text-success fw-bold'>
                                            <li>{formatNumber(fxRateValue?.fx)}</li>
                                            <li>{formatNumber(fxRateValue?.fees)}</li>
                                            <li>{formatNumber(fxRateValue?.tcs)}</li>
                                        </ul>   
                                    </div>
                                </div>
                            </div>
                            <div className='my-4'>
                                <p className='text-success'>Exchange in your currency</p>
                                <div className='d-flex justify-content-center gap-5'>
                                    <div className='col-5'>
                                        <input type='text' className='form-control text-success shadow-none w-100' value='INR' disabled />
                                    </div>
                                    <div className='col-5'>
                                        <input
                                            type='text'
                                            className='form-control shadow-none w-100 text-success'
                                            placeholder='Total Amount'
                                            value={formatNumber(fxRateValue?.finalAmount)}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='text-end mt-3'>
                                <button className='btn btn-success px-3 py-2 rounded-3 border-1'> Proceed </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default TransactionPage;
